<template>
  <div id="layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: "empty-layout"
};
</script>
